import { api } from 'api/api';
import { Role } from 'types/role';

export const ROLE_URL = 'Role' as const;

export const readRoleById = (params: { id: string }) =>
    api.get<Role>(ROLE_URL, {
        params,
    });
